import axios from "@/plugins/axios";

let url = (data) => "/api/v1/company/interviews/${_interview}/extraviewees".interpolate(data);

export const extraviewees = {
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
};

export default extraviewees;
